/**
 * @file     imageFade.ts
 * @purpose  Ref callback that fades an image in when it finishes loading. Only images still loading at hydration are touched, so server-rendered and already-painted photos (the LCP among them) never start hidden.
 */

export const fadeInOnLoad = (img: HTMLImageElement | null): void => {
  if (!img || img.complete) return;
  img.dataset.fade = 'pending';
  const done = () => {
    img.dataset.fade = 'in';
  };
  img.addEventListener('load', done, { once: true });
  img.addEventListener('error', done, { once: true });
};
